module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-5abbb9ccc740bc4f83a7e5243d02216e.png";